/* istanbul ignore file -- loggers */
import { getLogger, LogLevel } from '@ori/checkout-utils';
import { Logger } from '@ori/logger';
import { LIBRARY_NAME, LOG_COLOR, PACKAGE_NAME, TEAM_NAME } from './constants';
export const mainLogger = new Logger(PACKAGE_NAME, {
  teamName: TEAM_NAME
});
export const logDebug = getLogger(LIBRARY_NAME, LogLevel.Debug, LOG_COLOR);
//# sourceMappingURL=logger.js.map